export const host = "https://text-me-delta.vercel.app";
export const registerRoute = `${host}/api/auth/register`;
export const loginRoute = `${host}/api/auth/login`;
export const setAvatarRoute = `${host}/api/auth/setAvatar`;
export const allUsersRoute = `${host}/api/auth/allUsers`;

//chat
export const addMessage = `${host}/api/message/addmsg`;
export const getAllMessage = `${host}/api/message/getmsg`;
